import { getWidgetStyle, TextData, WidgetProps } from "@dto/Dashboard";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

export function TextCard(props: WidgetProps) {
    const { t } = useTranslation();
    const data = props.widget.data as TextData;
    const style = getWidgetStyle(props.widget);

    if (!data?.markdown) {
        return <div className="flex flex-col border-1 border-gray-200 rounded-md p-4" style={style}>{t("dashboard.overview.not.configured")}</div>;
    }

    return (
        <div className="flex flex-col border-0 border-gray-200 rounded-md p-4 overflow-auto prose prose-sm max-w-none" style={style}>
            <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                components={{
                    h1: ({ children }) => <h1 className="text-2xl font-bold mb-2">{children}</h1>,
                    h2: ({ children }) => <h2 className="text-xl font-semibold mb-2">{children}</h2>,
                    h3: ({ children }) => <h3 className="text-lg font-semibold mb-1">{children}</h3>,
                    p: ({ children }) => <p className="mb-2 text-sm">{children}</p>,
                    strong: ({ children }) => <strong className="font-bold">{children}</strong>,
                    em: ({ children }) => <em className="italic">{children}</em>,
                    ul: ({ children }) => <ul className="list-disc list-inside mb-2 text-sm">{children}</ul>,
                    ol: ({ children }) => <ol className="list-decimal list-inside mb-2 text-sm">{children}</ol>,
                    li: ({ children }) => <li className="mb-0.5">{children}</li>,
                }}
            >
                {data.markdown}
            </ReactMarkdown>
        </div>
    );
}
